import {
	Component,
	OnInit,
	PLATFORM_ID,
	Inject,
	HostBinding,
	Input,
	ChangeDetectorRef,
	Renderer2,
} from '@angular/core';
import { TransferState } from 'angular-engine/modules/transfer-state/transfer-state';
import { Router, NavigationEnd } from '@angular/router';
import { WindowRef } from 'angular-engine/engine/service/util';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/index';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from 'angular-engine/engine/state/reducer/core.reducer';
import * as coreActions from 'angular-engine/engine/state/action/core.actions';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Angulartics2Vdgm } from 'angular-engine/engine/providers/Angulartics2Vdgm';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { PubNubEngine } from 'angular-engine/engine/service/notification/pubnub.engine.service';
import {
	DEVICE_INFO,
	DeviceInfo,
	APP_SETTINGS,
} from 'angular-engine/modules/ng-express-engine/tokens';
import { ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var md = require('mobile-detect');

@Component({
	selector: 'app',
	templateUrl: 'app.template.html',
	styleUrls: ['global.style.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
	private isServer = false;
	private messages = [];
	private connection: any;
	private deviceType: DeviceInfo;
	private pubnubObservable: Observable<any>;
	private pubnubSubscription: Subscription;
	private liveSubscription: Subscription;
	public liveVideoClosed: boolean = false;
	public liveVideo: boolean = false;
	public lastMessage: any;
	private dataService: BehaviorSubject<Object>;
	public liveMeta: any;
	public superTitle: string;
	public alertTitle: string;
	public alertUrl: string;
	public alertUrlTarget: string;
	public alertPriority: string;
	public alertClosed: boolean = false;
	public hiddenTab: boolean = false;
	private visibilityChange: string = 'visibilitychange';
	private visibilityParam: string = 'hidden';

	public videoSource: any;

	@Input() isNotEmbed: boolean;

	@HostBinding('class.embed') isEmbed: boolean = false;

	@HostBinding('class.desktop') isDesktop: boolean = false;
	@HostBinding('class.phone') isPhone: boolean = false;
	@HostBinding('class.video') videoActive: boolean = false;
	@HostBinding('class.live') showVideo: boolean = false;
	@HostBinding('class.alertMode') showAlert: boolean = false;

	constructor(
		@Inject(PLATFORM_ID) platformId: string,
		@Inject(DEVICE_INFO) device: DeviceInfo,
		@Inject(APP_SETTINGS) private appSettings: any,
		private cache: TransferState,
		private winRef: WindowRef,
		private router: Router,
		private store: Store<fromRoot.State>,
		private stateInteraction: StateInteractionService,
		private coreEffects: CoreEffects,
		private analytics: Angulartics2Vdgm,
		private location2: Location,
		private userAuthService: UserLoginService,
		private pubnubEngine: PubNubEngine,
		private ref: ChangeDetectorRef,
		private renderer: Renderer2
	) {
		this.isServer = isPlatformServer(platformId);
		this.dataService = new BehaviorSubject(null);
		const self = this;
		if (!this.isServer) {
			if (this.appSettings.LIVE_ROUTE) {
				this.liveSubscription = this.dataService.subscribe((res) => {
					if (res) {
						self.liveMeta = res['meta'];
						self.videoSource = self.liveMeta.video_types;
					}
				});
				this.coreEffects.getApiUrlDataEmit(
					this.dataService,
					this.appSettings.LIVE_ROUTE,
					true
				);
			}
			if (this.appSettings.PUBNUB_ENABLED) {
				this.pubnubObservable =
					this.pubnubEngine.messageNotifier.asObservable();
			}
		}

		this.deviceType = device;
		/*if(this.appSettings.AUTH_ENABLED)
      {
        this.userAuthService.initOAuth();
      }*/

		//***************** */
	}

	ngOnDestroy() {
		if (this.liveSubscription) {
			this.liveSubscription.unsubscribe();
			this.liveSubscription = null;
		}
		if (this.pubnubSubscription) {
			this.pubnubSubscription.unsubscribe();
			this.pubnubSubscription = null;
		}
		if (this.dataService) {
			this.dataService.complete();
			//this.dataService.unsubscribe();
			this.dataService = null;
		}
	}

	ngOnInit() {
		const url = this.location2.path();
		if (url.match(/^\/embed\//)) {
			this.isNotEmbed = false;
			this.isEmbed = true;
			if (!this.isServer) {
				this.renderer.addClass(
					document.getElementsByTagName('html')[0],
					'embed'
				);
			}
		} else {
			this.isNotEmbed = true;
		}

		this.cache.set('cached', true);
		//this.initDeviceType();
		this.checkEventDefinition();
		if (this.deviceType.isDesktop) {
			this.isDesktop = true;
		}

		if (this.deviceType.isPhone) {
			this.isPhone = true;
		}

		if (!this.isServer && this.appSettings.AUTH_ENABLED && !this.isEmbed) {
			this.userAuthService.initOAuth();
		}

		if (!this.isServer && this.appSettings.PUBNUB_ENABLED) {
			this.pubnubSubscription = this.pubnubObservable.subscribe((res) => {
				this.lastMessage = res;
				this.checkForLive();
			});

			var hideAvailable = false;
			if (typeof document['hidden'] !== 'undefined') {
				// Opera 12.10 and Firefox 18 and later support
				hideAvailable = true;
				this.visibilityParam = 'hidden';
				this.visibilityChange = 'visibilitychange';
			} else if (typeof document['msHidden'] !== 'undefined') {
				hideAvailable = true;
				this.visibilityParam = 'msHidden';
				this.visibilityChange = 'msvisibilitychange';
			} else if (typeof document['webkitHidden'] !== 'undefined') {
				hideAvailable = true;
				this.visibilityParam = 'webkitHidden';
				this.visibilityChange = 'webkitvisibilitychange';
			}

			if (hideAvailable) {
				document.addEventListener(
					this.visibilityChange,
					() => {
						if (document[this.visibilityParam]) {
							this.hiddenTab = true;

							if (!this.liveVideoClosed && this.showVideo) {
								this.analytics.eventTrack('TabHidden', {
									event: 'videoEvent',
									category: 'LiveVideo',
									label: 'SoundOff',
								});
							}
						} else {
							this.hiddenTab = false;

							if (!this.liveVideoClosed && this.showVideo) {
								this.analytics.eventTrack('TabVisibleStart', {
									event: 'videoEvent',
									category: 'LiveVideo',
									label: 'SoundOff',
								});
							}
						}

						this.ref.detectChanges();
					},
					false
				);
			}
		}

		this.router.events
			.filter((event) => event instanceof NavigationEnd)
			.subscribe((val: NavigationEnd) => {
				if (
					val.url.indexOf('video') != -1 ||
					val.url.indexOf('episode') != -1 ||
					val.url.indexOf('stream') != -1
				) {
					this.videoActive = true;
				} else {
					this.videoActive = false;
				}

				if (!this.isServer) {
					this.checkForLive(val.url);
				}
			});

		if (!this.isServer && this.appSettings.SUPPORTS_PUSH_NOTIFICATIONS) {
			const pushUrl = this.appSettings.PUSH_NOTIFICATION_SERVICE_URL;

			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.addEventListener('message', (event) => {
					const url = new URL(event.data.url);
					this.navigateTo(url.pathname);
				});

				let swPromise = navigator.serviceWorker.register('/service-worker.js', {
					scope: '/',
				});
				swPromise
					.then(function (registration) {
						registration.update();

						return registration.pushManager.subscribe({
							userVisibleOnly: true,
						});
					})
					.then(function (subscription) {
						return fetch(pushUrl, {
							method: 'POST',
							body: JSON.stringify(subscription),
							headers: new Headers({
								'Content-Type': 'application/json',
							}),
						});
					})
					.catch(function (err) {
						console.log('There was a problem with the Service Worker');
						console.log(err);
					});
			}
		}

		if (window && window.matchMedia) {
			const html = window.document.getElementsByTagName('html')[0];
			const lightModeEnabled = window.matchMedia(
				'(prefers-color-scheme: light)'
			);

			if (lightModeEnabled.matches) {
				html.classList.add('light-mode');
			}

			const toggleColorTheme = (event) => {
				if (event.matches) {
					html.classList.add('light-mode');
				} else {
					if (html.classList.contains('light-mode')) {
						html.classList.remove('light-mode');
					}
				}
			};

			lightModeEnabled.addListener(toggleColorTheme);

			// This "fix" is for Safari/tests. They removed addEventListener from MediaQueryList -_-
			// lightModeEnabled.hasOwnProperty('addEventListener')
			//   ? lightModeEnabled.addEventListener('change', (event): void toggleColorTheme)
			//   : lightModeEnabled.addListener(toggleColorTheme);
		}
	}

	private checkForLive(routeValue: string = '') {
		const isLive = this.coreEffects.getInternalStateValue('liveVideo');
		if (this.lastMessage) {
			if (this.lastMessage.received.message['live']) {
				this.liveVideo = true;

				if (
					!this.liveVideoClosed &&
					routeValue.indexOf('streams') == -1 &&
					!isLive
				) {
					if (!this.showVideo) {
						this.analytics.eventTrack('start', {
							event: 'videoEvent',
							category: 'LiveVideo',
							label: 'SoundOff',
						});
					}

					this.showVideo = true;
					if (this.lastMessage.received.message['super']) {
						this.superTitle =
							this.lastMessage.received.message['super']['title'];
					}
				} else {
					this.showVideo = false;
				}
			} else {
				if (!this.liveVideoClosed) {
					this.analytics.eventTrack('AutoClose', {
						event: 'videoEvent',
						category: 'LiveVideo',
						label: 'SoundOff',
					});
				}

				this.liveVideo = false;
				this.showVideo = false;
				this.liveVideoClosed = false;
			}

			if (this.lastMessage.received.message['notification']) {
				if (!this.alertClosed) {
					this.showAlert = true;
					this.alertTitle =
						this.lastMessage.received.message['notification']['message'];
					this.alertPriority =
						this.lastMessage.received.message['notification']['importance'];
					if (
						this.lastMessage.received.message['notification']['interactions'] &&
						this.lastMessage.received.message['notification']['interactions']
							.length > 0
					) {
						const interaction =
							this.lastMessage.received.message['notification'][
								'interactions'
							][0];
						this.alertUrl = this.createInteractionRoute(
							interaction.item.obj_type,
							interaction.item.slug,
							interaction.item.details_url
						);
					} else {
						this.alertUrl = '';
					}
				}
			} else {
				this.showAlert = false;
				this.alertClosed = false;
			}

			this.ref.detectChanges();
		}
	}

	public navigateTo(route: string) {
		this.router.navigateByUrl(route);
	}

	public createInteractionRoute(
		type: string,
		slug: string,
		detailsUrl: string
	) {
		let url = '';

		switch (type) {
			case 'Section':
				if (slug == 'home') {
					url = '/';
				} else {
					url = detailsUrl.replace(this.appSettings['DATA_API_ENDPOINT'], '');
				}
				break;
			default:
				url = detailsUrl.replace(this.appSettings['DATA_API_ENDPOINT'], '');
		}

		return url;
	}

	public removeLiveNotification() {
		this.showVideo = false;
		this.liveVideoClosed = true;

		this.analytics.eventTrack('Close', {
			event: 'videoEvent',
			category: 'LiveVideo',
			label: 'SoundOff',
		});

		this.ref.detectChanges();
	}

	public removeAlertNotification() {
		this.showAlert = false;
		this.alertClosed = true;

		this.ref.detectChanges();
	}

	public goToLive() {
		this.showVideo = false;
		this.navigateTo('/streams/nratv');
	}

	private checkEventDefinition() {
		//in Internet Explorer the 'Event' is an object, not a function prototype, therefore
		//creting custom events using the "'new Event('name')" syntax does not work
		//we need to override the object and assign the CustomEvent function
		if (typeof Event === 'object') {
			window['Event'] = CustomEvent;
		}
	}
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/app.component.ts